import { Layout as AntdLayout } from "antd";
import styled from "styled-components";

export const StyledHeader = styled(AntdLayout.Header)`
  height: 64px;
  color: #fff;
  box-shadow: var(--shadow-medium);
  z-index: 999;
  background: var(--gradient-header);
  transition: box-shadow var(--transition-base);

  &:hover {
    box-shadow: var(--shadow-strong);
  }
`;

export const StyledHeaderNoAuth = styled(AntdLayout.Header)`
  color: #fff;
  height: 80px;
  position: fixed;
  width: 100%;
  z-index: 999;
  background: var(--gradient-header);
  padding: var(--space-3) var(--space-6) !important;
  box-shadow: var(--shadow-medium);
`;

export const StyledHeaderAuth = styled(AntdLayout.Header)`
  color: #fff;
  height: 80px;
  position: fixed;
  width: 100%;
  z-index: 999;
  padding-left: var(--space-8);
  padding-right: var(--space-6);
  background: var(--gradient-header);
  box-shadow: var(--shadow-medium);

  .headerMenuDropdown .ant-menu-submenu::after {
    border-bottom: none !important;
  }
`;